module.exports = __webpack_public_path__ + "media/javascripts/apps/roku/assets/images/TVslide-3-b6972ee4ebc23f48bc8a64e4403955aa.png";